import { Loader } from "@/components/Loader";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CircleAlert } from "lucide-react";
import { useEffect } from "react";
import { useLocation, useSearch } from "wouter";
import { ForecastDiagnosis } from "./ForecastDiagnosis";
import {
  StateOfSalesFilters,
  stateOfSalesForecastPeriodOptions,
} from "../state-of-sales-v2/ForecastFilters";
import { useStateOfSalesV2Forecast } from "../state-of-sales-v2/useForecastData";
import { useForecastDiagnosisStory } from "./useForecastDiagnosisStory";

export function RevenueIntelligenceForecastDiagnosisPage() {
  const filterModel = useStateOfSalesV2Forecast({ view: "overview" });
  const story = useForecastDiagnosisStory(filterModel);

  return (
    <div className="space-y-8 pb-10">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Forecast confidence</h1>
          <p className="mt-1 text-sm text-gray-500">
            Can the CRM forecast be trusted—and what outcome does the evidence support?
          </p>
        </div>
        <StateOfSalesFilters
          model={filterModel}
          periodOptions={stateOfSalesForecastPeriodOptions}
        />
      </div>

      {filterModel.isLoading ? (
        <Loader />
      ) : filterModel.error || !story ? (
        <Card className="border-dashed">
          <CardContent className="flex min-h-64 flex-col items-center justify-center gap-3 text-center">
            <CircleAlert className="h-5 w-5 text-gray-400" />
            <div>
              <p className="text-sm font-medium">Forecast confidence could not be loaded</p>
              <p className="mt-1 text-xs text-gray-500">A required forecast source could not be reached. Check the data connection and try again.</p>
            </div>
            <Button variant="outline" size="sm" onClick={() => void filterModel.retry()}>Try again</Button>
          </CardContent>
        </Card>
      ) : (
        <ForecastDiagnosis story={story} />
      )}
    </div>
  );
}

export function LegacyForecastDiagnosisRedirect() {
  const [, setLocation] = useLocation();
  const search = useSearch();

  useEffect(() => {
    setLocation(
      `/revenue-intelligence/state-of-sales-v2/forecast${search ? `?${search}` : ""}`,
      { replace: true },
    );
  }, [search, setLocation]);

  return null;
}
